import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeedbackManageComponent } from './feedback-manage/feedback-manage.component';
import { AssignHrForBusinessUnitComponent } from './assign-hr-for-business-unit/assign-hr-for-business-unit.component';

const adminRoutes: Routes = [
    { path: 'admin/extra/assignment', component: AssignHrForBusinessUnitComponent },
    { path: 'admin/extra/feedback-manage', component: FeedbackManageComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(adminRoutes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AdditionalAdminFeaturesRouteModule { }
